import { Link } from 'react-router-dom';

import SaleForm from '@/resources/components/global/saleForm.tsx/SaleForm';
import Price from '@/resources/components/product/price/Price';
import { useSlug } from '@/resources/hooks/useSlug';
import { IProduct } from '@/store/ducks/products/types';

import defaultImage from '../../../assets/images/product-load.svg';

export function MobileDetails({ product }: { product: IProduct }) {
  const slug = useSlug({ str: product.title });

  return (
    <Link
      to={`/product/${product.product_id}/${encodeURIComponent(slug)}`}
      className="product-details-wrapper"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="product-info">
        <span className="product-title">{product.title}</span>
        <p className="product-description">{product.description}</p>
      </div>
      <div className="product-content pr-0 mt-0">
        <div className="product-image">
          <img
            src={product.images?.[0] || defaultImage}
            alt={product.title}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = defaultImage;
            }}
          />
        </div>
        <div className="product-footer pr-3 pt-2">
          {product.price && (
            <Price
              defaultPrice={product.default_price}
              price={product.price}
              rewardPrice={product.alerts.find((alert) => alert.type === 'reward')?.price || 0}
              showDiscount
              discountType="rounded"
            />
          )}

          <SaleForm
            fullWidth
            product={product}
            currentMeasure="unity"
            styles={{
              position: 'relative',
              marginTop: '0',
              padding: '0',
              width: '100%',
              paddingTop: '0.4rem',
              paddingLeft: '1rem',
              bottom: 0,
              right: 0,
            }}
          />
        </div>
      </div>
    </Link>
  );
}
